
















import {Component, Prop, Vue} from "vue-property-decorator";
import TimeTrackingStatisticsToday from "@/views/Service/TimeTracking/Statistics/TimeTrackingStatisticsToday.vue";
@Component({
  components: {TimeTrackingStatisticsToday}
})
export default class Panel extends Vue {
  public name: string = "Panel";

  @Prop({required: true})
  public tabs!: Array<string>;


}
